export enum ContentVariants {
  'link' = 'link',
  'text' = 'text',
}

export enum ReplacementValues {
  'Condiciones' = 'Condiciones',
  'Politica' = 'Politica',
  'Name' = 'Name',
  'Value' = 'Value',
}

export const ReplacementConfig: Record<ReplacementValues, ContentVariants> = {
  Condiciones: ContentVariants.link,
  Politica: ContentVariants.link,
  Name: ContentVariants.text,
  Value: ContentVariants.text,
}
